import { AlertTriangle } from "lucide-react";

interface AccessErrorAlertProps {
  readonly message: string;
  readonly testId: string;
}

/** The inline failure box of an access dialog: our own copy, never the server's message. */
export function AccessErrorAlert({ message, testId }: AccessErrorAlertProps) {
  return (
    <div
      data-testid={testId}
      role="alert"
      className="flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/5 p-3"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-destructive" aria-hidden="true" />
      <p className="text-sm font-medium text-destructive">{message}</p>
    </div>
  );
}
